import BranchSelector from "components/organism/BranchSelector";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { buildDashBoardPath } from "pages/routes";

const SelectBranchPage: FC = () => {
  const [bId, setBid] = useState("");
  const navigate = useNavigate();

  return (
    <div className="">
      <p>どの店舗を確認しますか？</p>
      <div className="my-2">
        <BranchSelector onChange={(_bId) => setBid(_bId)} />
      </div>
      <div className="my-2">
        <button
          className="button "
          onClick={() => navigate(buildDashBoardPath(bId))}
          disabled={bId === ""}
        >
          ダッシュボードへ
        </button>
      </div>
    </div>
  );
};

export default SelectBranchPage;
